<template>
  <div>
    <header class="admin_header">
      <div class="admin_header_logo">
        <img src="@/images/admin-logo.png" alt="kingdomlogo" />
        <span>訂單管理後台</span>
      </div>
      <div class="admin_header_button">
        <span class="logout" @click="loginOut">登出</span>
        <router-link
          to="/admin/edit_goldFee"
          v-if="isCanModifyPriceAndSpecialMemberManage"
          >工錢修改</router-link
        >
        <router-link to="/admin/latest_newsList">最新消息管理</router-link>
        <router-link
          to="/admin/special_memberList"
          v-if="isCanModifyPriceAndSpecialMemberManage"
          >特約商管理</router-link
        >
      </div>
    </header>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  name: "admin_header",
  methods: {
    async loginOut() {
      let loginOutUserResponse = confirm("確定登出嗎？");
      if (loginOutUserResponse) {
        try {
          let loginOutResponse = await this.$store.dispatch(
            "backstageLoginOut"
          );
          if (loginOutResponse.result === "success") {
            this.$store.dispatch("deleteBackstageToken");
            Cookies.remove("goldAdminUser");
            this.$router.push({ name: "admin_login" });
          } else {
            alert("未成功登出，請稍候再試");
          }
        } catch (e) {
          alert(`錯誤訊息：${e.response.data.message}`);
        }
      }
    },
  },
  computed: {
    isCanModifyPriceAndSpecialMemberManage() {
      let adminLevel = this.$store.getters.getAdminLevel;
      if (adminLevel > 1) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.admin_header,
.admin_header_logo,
.admin_header_button {
  display: flex;
  align-items: center;
}
.admin_header {
  justify-content: space-between;
  height: 85px;
  border-bottom: 1px solid #ddd;
}
.admin_header_logo {
  img {
    margin: 0 10px;
  }
  span {
    color: $secondaryLightColor1;
    font-size: 20px;
    letter-spacing: 1.9px;
  }
}
.admin_header_button {
  flex: 1 1 auto;
  justify-content: flex-end;
  a,
  span {
    margin-right: 30px;
    font-size: 17px;
    color: $secondaryDeepColor1;
    border: 1px $secondaryDeepColor1 solid;
    border-radius: 2px;
    height: 35px;
    line-height: 35px;
    padding: 0 15px;
    &:hover {
      background-color: #eee;
    }
  }
  .logout {
    margin-right: auto;
    margin-left: 20px;
  }
}
</style>
